import { Roles } from '../../constants/project.constant';

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
});

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '-';
  return DATE_TIME_FORMATTER.format(new Date(value)).replace(',', ' -');
}

export function isNullOrUndefined(value: any){
  if ( value == null || value == undefined){
    return true
  }
  return false;
}

export function isEmptyArray(value: any[]): boolean {
  return isNullOrUndefined(value) || value.length === 0;
}

export function compareStrings(a: string, b: string): number {
  return a.localeCompare(b);
}

export function arraysEqual(a: string[], b: string[]): boolean {
  if (!a || !b) return a === b;
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort(compareStrings);
  const sortedB = [...b].sort(compareStrings);
  return sortedA.every((val, i) => val === sortedB[i]);
}

export function isAuth0TokenError(error: any): boolean {
  const errorCode = error?.error || '';
  return errorCode === 'missing_refresh_token' ||
         errorCode === 'invalid_grant' ||
         errorCode === 'login_required';
}

export function clearAuthStorage(): void {
  localStorage.clear();
  sessionStorage.clear();
}

const AUTHORIZED_ROLES: string[] = [Roles.admin];

export function hasRequiredRole(roles: string[]): boolean {
  if (!roles || roles.length === 0) return false;
  return AUTHORIZED_ROLES.some(role => roles.includes(role));
}
